module.exports = __webpack_public_path__ + "img/867-f176e9.png";